import React from "react";
import PropTypes from "prop-types";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
import { DatePicker } from 'material-ui-pickers';
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Tooltip from '@material-ui/core/Tooltip';

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import moment from "moment";
import _ from "lodash";

import { bugs, website, server } from "variables/general.jsx";

import { DashboardStats } from "../../baseparking-api";

import {
  dailySalesChart,
  completedTasksChart,
  carsInChart,
  carsOutChart
} from "variables/charts.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

function mode(arr) {
  return arr.sort((a, b) =>
    arr.filter(v => v === a).length
    - arr.filter(v => v === b).length
  ).pop();
}

function formatISK(price) {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

class Dashboard extends React.Component {
  state = {
    value: 0,
    revenue: 0,
    services: 0,
    bookings: 0,
    unfinished: null,
    bookingData: null,
    byDay: null,
    carsIn: null,
    carsOut: null,
    parked: 0,

    statsFrom: moment(),
    statsTo: moment(),
  };

  componentWillMount() {
    this.fetchStats();
  }

  fetchStats = () => {
    DashboardStats.get(moment(this.state.statsFrom).format('YYYY-MM-DD'), moment(this.state.statsTo).format('YYYY-MM-DD')).then(res => {
      const { daily, weekly, latestOrders, carsIn, carsOut } = res.data.data;

      console.log(daily, weekly);
      
      const bookingData =
        daily.bookings &&
        daily.bookings.sort((a, b) => moment(b.dateCreated).valueOf() - moment(a.dateCreated).valueOf())
          .map((o, key) => [
            moment(o.dateCreated).format('DD-MM-YYYY HH:mm:ss'),
            o.vehicle.reg,
            `${o.coupons.length ? '🔖 ' : o.client.vip ? '🏆 ' : o.client.senior ? '👵 ' : ''}${o.client.name}`,
            formatISK(o.totalPrice.toString()) + ' kr.',
            o.client.vip ? `VIP - ${o.client.vip}%` : o.coupons.length ? `${o.coupons[0].labelThen} - ${o.coupons[0].discountThen}%` : o.client.senior ? 'Eldrib. - 10%' : '',
            o.stay.duration.toString() + " dagar",
            o.services ? o.services.map(s => s.labelThen).join(',') : " ",
            o.status === 'due' ? 'Ógreitt' : (o.arrived ? o.returned ? 'Bókun afgreidd' : 'Bíll á plani' : 'Bíll væntanlegur'),
          ]);


      let byDay = { labels: [], series: [[]] };
      Object.keys(weekly.sales).forEach(d => {
        byDay.labels.push(moment(d).format('D.M'));
        byDay.series[0].push(weekly.sales[d]);
        if (dailySalesChart.options.high < weekly.sales[d]) {
          dailySalesChart.options.high = weekly.sales[d] + 5;
        }
      })

      let carsInData = {
        labels: [],
        series: [[]],
        freq: null,
      };

      carsIn && carsIn.map(hour => {
        carsInData.labels.push(hour.hour);
        carsInData.series[0].push(hour.count);
      })
      carsInChart.options.high = carsIn.sort((a, b) => b.count - a.count)[0].count + 2;
      carsInData.freq = carsIn.sort((a, b) => b.count - a.count)[0].hour;

      let carsOutData = {
        labels: [],
        series: [[]],
        freq: null,
      };

      carsOut && carsOut.map(hour => {
        carsOutData.labels.push(hour.hour);
        carsOutData.series[0].push(hour.count);
      })
      completedTasksChart.options.high = carsOut.sort((a, b) => b.count - a.count)[0].count + 2;
      carsOutData.freq = carsOut.sort((a, b) => b.count - a.count)[0].hour;

      this.setState({ bookings: daily.bookings.length, revenue: daily.revenue, services: daily.services.length, freqService: mode(daily.services.map(s => s.labelThen)), parked: daily.parked, parkedByEnd: daily.parkedByEnd, bookingData, byDay, carsIn: carsInData, carsOut: carsOutData });

    })
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  groupday(value, index, array) {

  }
  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  render() {
    const { classes } = this.props;

    const byDayDelta = this.state.byDay && this.state.byDay.series[0][this.state.byDay.series[0].length - 1] / this.state.byDay.series[0][this.state.byDay.series[0].length - 2] * 100;

    return (
      <div>
        <div className={classes.statRangePicker}>
          <DatePicker
            label="Tími frá"
            value={this.state.statsFrom}
            className={classes.dateInput}
            onChange={date => this.setState({ statsFrom: date }, () => this.fetchStats())}
            format={'DD.MM.YYYY'}
            maxDate={moment(this.state.statsTo)}
            animateYearScrolling
            autoOk={true}
            okLabel={'Staðfesta'}
            cancelLabel={'Hætta við'}
          />
          <DatePicker
            label="Tími til"
            value={this.state.statsTo}
            className={classes.dateInput}
            onChange={date => this.setState({ statsTo: date }, () => this.fetchStats())}
            format={'DD.MM.YYYY'}
            animateYearScrolling
            maxDate={moment()}
            minDate={moment(this.state.statsFrom)}
            autoOk={true}
            okLabel={'Staðfesta'}
            cancelLabel={'Hætta við'}
          />
          <Tooltip title='Velja daginn í dag'>
            <DateRange onClick={e => this.setState({ statsFrom: moment(), statsTo: moment() }, () => this.fetchStats())} />
          </Tooltip>
        </div>
        <GridContainer>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Icon>time_to_leave</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Bókanir</p>
                <h3 className={classes.cardTitle}>
                  {this.state.bookings}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  {moment(this.state.statsFrom).format('MM.DD.YY')} - {moment(this.state.statsTo).format('MM.DD.YY')}
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Icon>attach_money</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Tekjur</p>
                <h3 className={classes.cardTitle}>
                  {formatISK(this.state.revenue)} <small>ISK</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  {moment(this.state.statsFrom).format('MM.DD.YY')} - {moment(this.state.statsTo).format('MM.DD.YY')}
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Icon>local_car_wash</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Aukaþjónustur</p>
                <h3 className={classes.cardTitle}>{this.state.services}</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <LocalOffer />
                  Vinsælasta þjónustan: {this.state.freqService}
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Icon>local_parking</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Bílar á plani</p>
                <h3 className={classes.cardTitle}>{this.state.parked && this.state.parked}</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Update />
                  Verða {this.state.parkedByEnd} í lok dags ( 00: 00 )
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          {/* Tekjur vikunnar */}
          <GridItem xs={12} sm={12} md={4}>
            <Card chart>
              <CardHeader color="success">
                {this.state.byDay && <ChartistGraph
                  className="ct-chart"
                  data={this.state.byDay}
                  type="Line"
                  options={dailySalesChart.options}
                  listener={dailySalesChart.animation}
                />}
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Bókanir daglega</h4>
                {
                  byDayDelta > 100 ?
                    <p className={classes.cardCategory}>
                      <span className={classes.successText}>
                        <ArrowUpward className={classes.upArrowCardCategory} />
                        {this.state.byDay && Math.round(this.state.byDay.series[0][this.state.byDay.series[0].length - 1] / this.state.byDay.series[0][this.state.byDay.series[0].length - 2] * 100)}% aukning á bókunum á milli daga.
                      </span>
                    </p>
                    :
                    <p className={classes.cardCategory}>
                      <span className={classes.errorText}>
                        <ArrowDownward className={classes.upArrowCardCategory} />
                        {this.state.byDay && Math.round(100 - this.state.byDay.series[0][this.state.byDay.series[0].length - 1] / this.state.byDay.series[0][this.state.byDay.series[0].length - 2] * 100)}% færri bókanir en í gær.
                    </span>
                    </p>

                }
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <Icon>attach_money</Icon> Meðalupphæð bókana í dag: {this.state.revenue && formatISK(Math.round(this.state.revenue / this.state.bookings))} ISK
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          {/* Bílar inn */}
          <GridItem xs={12} sm={12} md={4}>
            <Card chart>
              <CardHeader color="info">
                {this.state.carsIn && <ChartistGraph
                  className="ct-chart"
                  data={this.state.carsIn}
                  type="Line"
                  options={carsInChart.options}
                  listener={carsInChart.animation}
                />}
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Bílar: Inn</h4>
                <p className={classes.cardCategory}>
                  {this.state.carsIn && this.state.carsIn.freq}:00 - Uppteknasti Tíminn
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <Icon>time_to_leave</Icon> {this.state.carsIn && this.state.carsIn.series[0].reduce((a, b) => a + b)} bílar væntanlegir á næsta sólahring
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          {/* <GridItem xs={12} sm={12} md={4}>
            <Card chart>
              <CardHeader color="info">
                <ChartistGraph
                  className="ct-chart"
                  data={emailsSubscriptionChart.data}
                  type="Bar"
                  options={emailsSubscriptionChart.options}
                  responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                  listener={emailsSubscriptionChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Email Subscriptions</h4>
                <p className={classes.cardCategory}>
                  Last Campaign Performance
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent 2 days ago
                </div>
              </CardFooter>
            </Card>
          </GridItem> */}
          {/* Bílar út */}
          <GridItem xs={12} sm={12} md={4}>
            <Card chart>
              <CardHeader color="info">
                {this.state.carsOut && <ChartistGraph
                  className="ct-chart"
                  data={this.state.carsOut}
                  type="Line"
                  options={completedTasksChart.options}
                  listener={completedTasksChart.animation}
                />}
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Bílar: Út</h4>
                <p className={classes.cardCategory}>
                  {this.state.carsOut && this.state.carsOut.freq}:00 - Uppteknasti Tíminn
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <Icon>time_to_leave</Icon> {this.state.carsOut && this.state.carsOut.series[0].reduce((a, b) => a + b)} viðskiptavinir væntanlegir tilbaka á næsta sólahring
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          {/* <GridItem xs={12} sm={12} md={6}>
            <CustomTabs
              title="Tasks:"
              headerColor="primary"
              tabs={[
                {
                  tabName: "Bugs",
                  tabIcon: BugReport,
                  tabContent: (
                    <Tasks
                      checkedIndexes={[0, 3]}
                      tasksIndexes={[0, 1, 2, 3]}
                      tasks={bugs}
                    />
                  )
                },
                {
                  tabName: "Website",
                  tabIcon: Code,
                  tabContent: (
                    <Tasks
                      checkedIndexes={[0]}
                      tasksIndexes={[0, 1]}
                      tasks={website}
                    />
                  )
                },
                {
                  tabName: "Server",
                  tabIcon: Cloud,
                  tabContent: (
                    <Tasks
                      checkedIndexes={[1]}
                      tasksIndexes={[0, 1, 2]}
                      tasks={server}
                    />
                  )
                }
              ]}
            />
          </GridItem> */}
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="warning">
                <h4 className={classes.cardTitleWhite}>Bókanir í dag</h4>
                <p className={classes.cardCategoryWhite}>
                  Síðasta bókun kom inn þann 20 Nóvember, 21:30 <br />🔖=afsláttarkóði 🏆=VIP 👵=eldri borgari
                </p>
              </CardHeader>
              <CardBody>
                {this.state.bookingData && <Table
                  tableHeaderColor="warning"
                  tableHead={["Dagsetning", "Bílnúmer", "Nafn", "Upphæð", "Afsláttur", "Geymslulengd", "Þjónustur", "Staða"]}
                  tableData={this.state.bookingData}
                />}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx